<template>
  <div class="box1-container">
    <div class="title">智慧照明</div>
    <div class="content">
      <div class="cont-left">
        <ul>
          <li>
            <span class="l0">{{ itemData.total }}</span
            >总安装
          </li>
          <li>
            <span class="l1">{{ itemData.online }}</span
            >在线
          </li>
          <li>
            <span class="l2">{{ itemData.lamp_light }}</span
            >亮灯
          </li>
          <li>
            <span class="l3">{{ itemData.malfunction }}</span
            >故障
          </li>
        </ul>
        <div class="left-box2">
          <div class="tit-text">
            用电量<br /><span class="red">{{ parseInt(itemData.cost_electricity) }}</span>kWh
          </div>
          <img src="@/assets/home_images/box1/box1_left.png" />
          <div class="tit-text">
            省电量<br /><span>{{ parseInt(itemData.save_electricity) }}</span>kWh
          </div>
        </div>
      </div>
      <div class="cont-right">
        <div class="box-one">
          <span>电压</span><em>{{ itemData.voltage }}V</em>
        </div>
        <div class="box-one">
          <span>电流</span><em>{{ itemData.current }}</em>
        </div>
        <div class="box-one">
          <span>亮度</span><em>{{ itemData.light }}%</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Box1",
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          online: 0,
          lamp_light: 0,
          malfunction: 0,
          cost_electricity: 0,
          total_electricity: 0,
          save_electricity: 0,
          light: 0,
          colorTemperature: 0,
          voltage: 0,
          current: 0,
          power: 0,
          Power_factor: 0,
          light_time: 0,
          lamp_id: 0
        };
      },
    },
  },
  data() {
    return {}
  },
};
</script>
<style lang='less'>
.box1-container {
  width: 100%;
  height: 100%;
  position: relative;

  .title {
    font-size: 18px;
    line-height: 30px;
    font-weight: normal;
    color: #fff;
    display: block;
    width: 100%;
  }
  .content {
    position: absolute;
    padding-top: 30px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // align-items: center;
    box-sizing: border-box;
    top: 0;
    left: 0;
    .cont-left {
      width: 62%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      flex-wrap: wrap;
      overflow: hidden;
      ul {
        width: 100%;
        margin: 0;
        padding: 20px 0 8px;
        list-style: none;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          span {
            display: block;
            margin-bottom: 5px;
            font-size: 32px;
            font-weight: normal;
            color: rgb(119, 198, 254);
            text-shadow: 0 0 10px rgba(119, 198, 254, 0.5);
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          }
          span.l1 {
            color: rgb(0, 187, 172);
            text-shadow: 0 0 10px rgba(0, 187, 172, 0.7);
          }
          span.l2 {
            color: rgb(255, 255, 255);
            text-shadow: 0 0 10px rgba(255, 255, 255, 0.7);
          }
          span.l3 {
            color: rgb(226, 48, 100);
            text-shadow: 0 0 10px rgba(226, 48, 100, 0.7);
          }
        }
      }

      .left-box2 {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 10px 0;
        .tit-text {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
          line-height: 1.5;
          span{
            font-size: 14px;
            color:#00bbac;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-style: normal;
          }
          .red{
            color:#e23064
          }
        }
        img {
          width: auto;
          height: 40px;
        }
      }

      .left-box3 {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 0;
        .box-one {
          color: rgba(255, 255, 255, 0.7);
          display: flex;
          align-items: center;
          padding-left: 20px;
          font-size: 12px;
          line-height: 1.2;
          span {
            color: rgba(255, 255, 255, 0.7);
            font-size: 12px;
            margin-top: 10px;
          }
          h5 {
            color: #6aabfd;
            font-size: 28px;
            font-weight: normal;
            margin: 0 3px;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-style: normal;
          }
          em {
            color: #6aabfd;
            font-size: 16px;
            font-style: normal;
            margin-top: 10px;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-style: normal;
          }
        }
        .box-one:last-child {
          padding-left: 0;
          padding-right: 20px;
        }

        .jindu{
          width:100%;
          background: rgba(255,255,255,.15);
          height:5px;
          border-radius: 5px;
          overflow: hidden;
          line-height: 0;
          margin-top:5px;
          span{
            display: block;
            width:50%;
            background: #6aabfd;
            height:5px;
            border-radius: 5px;
          }
        }
      }
    }

    .cont-right {
      width: 32%;
      display: flex;
      justify-content: space-evenly; /* 水平均匀分布 */
      align-items: center; /* 垂直居中 */
      flex-direction: column;
      .box-one {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        line-height: 1.2;
        background: url(../../assets/home_images/power_bg.png);
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: right center;
        padding: 10px 20px;
        height:36px;
        width: 100%;
        box-sizing: border-box;
        margin: 5px 0;
        span {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
        }
        em {
          font-size: 14px;
          color:#77c6fe;
          font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          font-style: normal;
        }
      }
    }
  }
}
</style>
